import React from 'react'

const ValidationMessage = (props) => {
    const { className , message} = props;
    return (
        <>
            <div className={`${className}`}>
                {message}
            </div>
        </>
    )
}

export default ValidationMessage